import { Router, ActivatedRoute } from '@angular/router';
import { enableProdMode } from '@angular/core';
import { LoggerService } from './shared/sdk/services/custom/logger.service';
import { GlobalPropertiesService } from './core.module/services/global-properties.service';
import { Component, OnInit, HostBinding } from '@angular/core';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  // set the host element classes
  // hostbinding syntax @HostBinding('class.classname') get DummyFunction() { return theResultToReturn; }
  // hostbinding syntax #2 (shorthand) @HostBinding('class.classname') returnVar =  theResultToReturn;

  // @HostBinding('class.lyt-2') true;
  // @HostBinding('class.app-mobile') appMobile = this.globalProps.appGlobal.isMobile;
  // @HostBinding('class.app-navbar-fixed') appNavbarFixed = this.globalProps.appGlobal.layout.isNavbarFixed;
  public app = this.globalProps.appGlobal;

  constructor(
    public globalProps: GlobalPropertiesService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {


  }

  ngOnInit(
  ) {

    console.log('kalipsoRC Loaded... Ready to rock. v' + this.globalProps.appGlobal.version);

    document.addEventListener('touchmove', function (event: any) {
      event = event.originalEvent || event;
      if (event.scale && event.scale !== 1) {
        event.preventDefault();
      }
    }, false);

  }




}





// WEBPACK FOOTER //
// ./src/app/app.component.ts